import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTheme, Button } from "@mui/material";

import { confirmReset } from "../../helpers/firebase";

import SimpleBox from "../../components/layout/container/SimpleBox";
import PasswordInput from "../../components/input/text/PasswordInput";
import UserContainer from "../../components/layout/container/UserContainer";
import { validatePassword } from "../../helpers/validation";

const ResetPassword = () => {

    const navigate = useNavigate();
    const theme = useTheme();

    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    const code = searchParams.get('code');

    const [password, setPassword] = React.useState(null);
    const [passwordConfirmation, setPasswordConfirmation] = React.useState(null);
    const [errors, setErrors] = React.useState({password: null, passwordConfirmation: null});

    const validate = () => {
        const newErrors = {
            password: validatePassword(password),
            passwordConfirmation: passwordConfirmation !== password ? "As passwords não coincidem" : null,
        };

        setErrors(newErrors);
        if (newErrors.password !== null || newErrors.passwordConfirmation !== null) { return false; }
        return true;
    }

    const handleSubmit = () => {
        const err = validate();
        if (!err) { return; }

        confirmReset(code, password, ({ error }) => {
            if (error === null) {
                toast.success("A password foi alterada com sucesso!");
                return navigate("/login");
            }
            else {
                let message = "";
                switch (error.code) {
                    case "auth/email-already-in-use":
                        message = "O email já está a ser utilizado por outra conta.";
                        break;
                    case "auth/invalid-email":
                        message = "O email não é válido.";
                        break;
                    case "auth/operation-not-allowed":
                        message = "O email e a password não estão ativos.";
                        break;
                    case "auth/weak-password":
                        message = "A password é muito fraca.";
                        break;
                    default:
                        message = "Ocorreu um erro ao criar a conta. Por favor, tente novamente mais tarde ou contacte-nos.";
                        break;
                }
                toast.error(message);
            }
        });
    }

    return (
        <UserContainer
            title="Criar Nova Password"
            message={`Crie uma nova password para o email ${email}`}
        >
            <SimpleBox gap={4} flexDirection="column" mt={6} alignItems="left">
                <PasswordInput
                    value={password}
                    errorText={errors.password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setErrors({...errors, password: null});
                    }} />
                <PasswordInput
                    value={passwordConfirmation}
                    errorText={errors.passwordConfirmation}
                    onChange={(e) => {
                        setPasswordConfirmation(e.target.value);
                        setErrors({...errors, passwordConfirmation: null});
                    }}
                    label="Confirmar Palavra Passe" />
                <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit}>Enviar</Button>
            </SimpleBox>
        </UserContainer>
        
    );
};

export default ResetPassword;
